import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_update_status_lock = createAsyncThunkSafe<void, DTO__generation>(
  ENUM__network_event_client_to_server.GENERATION_UPDATE_STATUS_LOCK,
  async generation => {
    generation = generation.clone();
    generation.tool = DTO__generation_tool.CREATE_STUB();

    await send_to_server(ENUM__network_event_client_to_server.GENERATION_UPDATE_STATUS_LOCK, generation);
  },
);

export function INIT_REMOTE__generation_update_status_lock(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_update_status_lock.pending, (state, action) => {
      let generation = action.meta.arg;

      let { generations_map } = state;

      generations_map.set(generation._id, generation);

      state.generations_map = new Map(generations_map);
    })
    .addCase(REMOTE__generation_update_status_lock.rejected, (state, action) => {})
    .addCase(REMOTE__generation_update_status_lock.fulfilled, (state, action: PayloadAction<void>) => {});
}
